import React, { Component } from 'react';
import { Button, Table, Divider } from 'semantic-ui-react';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class SendToUpdateFabric extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }


    sendTo = () => {
        history.push("/dashboard/updateFabricPayment/"+this.props.idfabricPayments)
    }
    

    render() { 

        const sendButton = this.props.fabricPayment && this.props.fabricPayment.paymentImageLink
         ? <div>
             <a href={this.props.fabricPayment.paymentImageLink} target="_blank">View Recpt</a>
         </div>
         : <Button onClick={this.sendTo}>UPDATE</Button>

        return ( <div>
            {sendButton}
          </div> );
    }
}
 
export default SendToUpdateFabric;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/SendToUpdateFabric.js